export default __webpack_public_path__ + "static/media/ic_floatchat.655a2291.svg";